import React, { FC } from 'react';

import { HeaderFooterType } from '@/pages/layout/layout';
import { useStore } from '@/store/';

interface IGlobalState {
  children: React.ReactNode;
  headerFooterData?: HeaderFooterType;
}

const GlobalState: FC<IGlobalState> = ({ children, headerFooterData }) => {
  const updateHeaderFooter = useStore(({ setHeaderFooter }) => setHeaderFooter);

  updateHeaderFooter(headerFooterData!);

  return <>{children}</>;
};

export default GlobalState;
